// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    getAlsoPurchasedProductsCollectionV2,
    getProductCollectionV2,
    getRelatedProductsCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

export const XngPopulateApiParameter: typeof PopulateApiParameter = (props: any) => {
    if (!props.apiParameter.expand?.includes("properties")) {
        props.apiParameter.expand = [...(props.apiParameter.expand || []), "properties"];
    }
};

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        const { categories, ...rest } = props.apiParameter as any;

        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            props.apiResult = await getProductCollectionV2({
                ...rest,
                categoryId: categories ? (categories.length === 1 ? categories[0] : undefined) : rest.categoryId,
                properties: JSON.stringify({
                    plumbers_categoryIds: categories?.join(",") || "",
                }),
            });
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        throw error;
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
